interface Labels {
  [key: string]: string;
}

export const labels: Labels = {
  totalStrikes: 'Total de Golpes',
  significantStrikes: 'Golpe significativo',
  significantStrikesHead: 'G.S. Cabeça',
  significantStrikesBody: 'G.S Corpo',
  significantStrikesLegs: 'G.S Pernas',
  takedowns: 'Quedas',
  takedownAttempts: 'Tentativa de Queda',
  takedownsDefended: 'Queda Defendida',
  transitions: 'Transições',
  submissionAttempts: 'Tentativa de SUB',
  knockdowns: 'Knockdowns',
  elapsedControlTime: 'Tempo total de controle',
  controlStarted: 'Controle iniciado',
  controlEnded: 'Controle finalizado',
  roundStart: 'Round iniciado',
  roundEnd: 'Round finalizado',
  fightEnd: 'Luta finalizada',
  fightStart: 'Luta iniciada',
  nearFalls: 'Near Fall',
  exposures: 'Exposure',
  falls: 'Fall',
  pinnings: 'Pinning',
  roles: 'Role',
  reversals: 'Reversal',
  turnovers: 'Turnover',
  outOfBounds: 'Out of Bounds',
  escapes: 'Escape',
  stallings: 'Stalling',
  ridingTimes: 'Riding time',
  passivities: 'Passividade',
  advantages: 'Vantagem',
  cautions: 'Caution',
  backtakes: 'Backtakes',
  counterattacks: 'Counterattack',
  technicalViolations: 'Technical Violation',
  score: 'Score',
  timeout: 'Timeout',
  fightResult: 'Resultado da luta',
  timeout_start: 'Inicio do timeout',
  timeout_end: 'Fim do timeout',
  standing: 'Controle em pé',
  ground: 'Controle no chão',
  fence: 'Controle na grade',
  live: 'Ao vivo',
  inactive: 'Inativa',
  finish: 'Finalizada',
  pointsDeduction: 'Point deduction',
  Waiting: 'Aguardando',
};

export default labels;
